import { GerenciadorPrecos } from '../../../../@types/GerenciadorPrecos';
import { GerenciadorExpandedRowKeyState } from '../../../../reducers/gerenciadorPrecos/expandedRowKey';
import { ExpandedRowHeight } from './calculateExpandedRowHeight';

type RowData = GerenciadorPrecos.RowData;

const getBaseOfferExpandedHeight = () => ExpandedRowHeight.getRowHeight('HEADER') + ExpandedRowHeight.getRowHeight('OFFER');

export const getAutoOfferRowExpandedHeight = (rowData: RowData | undefined, expandedRowKey: GerenciadorExpandedRowKeyState) => {
  const baseOfferHeight = getBaseOfferExpandedHeight();

  if (!rowData || expandedRowKey.key !== rowData.productsToBePricedId) {
    return baseOfferHeight;
  }

  const competitorsHeight = expandedRowKey.options.includes('COMPETITORS') ? ExpandedRowHeight.getRowHeight('COMPETITORS') : 0;
  const offerCompetitorsHeight = expandedRowKey.options.includes('OFFERPRICE_COMPETITORS') ? ExpandedRowHeight.getRowHeight('OFFERPRICE_COMPETITORS') : 0;

  return baseOfferHeight + competitorsHeight + offerCompetitorsHeight;
};

type GetOfferRowExpansionStateParams = {
  datapoints: RowData[];
  expandedRowKey: GerenciadorExpandedRowKeyState;
  isOfferDataActive: boolean;
  autoExpandRows: boolean;
};

export const getOfferRowExpansionState = ({
  datapoints,
  expandedRowKey,
  isOfferDataActive,
  autoExpandRows,
}: GetOfferRowExpansionStateParams) => {
  const isAutoExpandActive = isOfferDataActive && autoExpandRows;

  if (isAutoExpandActive) {
    const expandedRowKeys = datapoints.filter(datapoint => !!datapoint.offerDetails).map(datapoint => datapoint.productsToBePricedId);

    return {
      isAutoExpandActive,
      expandedRowKeys,
      rowExpandedHeight: getBaseOfferExpandedHeight(),
    };
  }

  return {
    isAutoExpandActive,
    expandedRowKeys: expandedRowKey.key ? [expandedRowKey.key] : [],
    rowExpandedHeight: expandedRowKey.options.length <= 1 ? 0 : ExpandedRowHeight.calculateExpandedRowHeight(expandedRowKey.options),
  };
};
